import NewModals from "./new-modals";
import GAService from "./GAService";
import Cookies from "js-cookie";

const LOCALSTORAGE_KEY = "mrktmdl_a";
const COOKIE_NAME = "marketplaceModalDisplayed";

export default class MarketplaceModal {
  constructor() {
    this.modalId = "marketplace-modal";
    this.button = this.modalContainer = document.querySelector(
      `#${this.modalId}`
    );
    this.button = null;

    if (!this.modalContainer) {
      return;
    }

    this.showModal();
    this.resolveElements();
    this.addListeners();
  }

  resolveElements() {
    this.button = this.modalContainer.querySelector(
      "[data-marketplace-button]"
    );
  }

  addListeners() {
    if (this.button) {
      this.button.addEventListener("click", this.handleButtonClick.bind(this));
    }
  }

  handleButtonClick(e) {
   GAService.sendEvent("Marketplace Modal", "Modal button clicked", "");
  }

  showModal() {
    if (Cookies.get(COOKIE_NAME) !== "1") {
      setTimeout(() => {
        NewModals.open(this.modalId);
        Cookies.set(COOKIE_NAME, "1", {
          expires: 7,
        });
      }, 3000);
    }

    GAService.sendEvent("Marketplace Modal", "Modal displayed", "");
  }
}
